import { render, staticRenderFns } from "./IstanzeList.vue?vue&type=template&id=87e6394a&"
import script from "./IstanzeList.vue?vue&type=script&lang=js&"
export * from "./IstanzeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IstanzeList.vue"
export default component.exports